var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skin-dysfunctions-template',{attrs:{"dysfunctions":_vm.skinDysfunctions,"doctor-full-name":_vm.doctorFullName,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }